const handleMutationError = (errorInfo): void => {
  Array.isArray(errorInfo)
    ? alert("Errors: \n" + errorInfo.map((e) => e.message))
    : alert("Error: \n" + errorInfo);
};

export default handleMutationError;
